import { render, staticRenderFns } from "./SupplierAutosuggest.vue?vue&type=template&id=22944741"
import script from "./SupplierAutosuggest.vue?vue&type=script&lang=js"
export * from "./SupplierAutosuggest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports